import Translator from './Translator';

const translator = new Translator();

export function getTranslatedTexts(page, language_preference) {
  const translatedTexts = translator.translate(page, language_preference);

  return translatedTexts;
}
